/**
 * Manager (Collection) for ROB.
 * All ROB is really VoyageBulk in consumable tanks. And is not connected to the deprecated Fuel Object.
 * ROB is virtually grouped on a date, meaning that if there is a ROB 14.11.2016 in the FUEL and LNG tank these will be virtually be set on a RobRow.
 *
 */

var VRC = VRC || {};

VRC.RobManager = (function(){
	var _robRows = {};
	var _bulkTankIds;
	var KEY_FORMAT = 'YYYYMMDDHHmm';

	var init = function(){
		clear();

		var consumableTanks = VRC.BulkTankManager.getConsumable();

		consumableTanks = _.sortBy(consumableTanks, function(fuelTank){return fuelTank.getConsumableSeqNo()});
		var bulkTanksSimple = _.map(consumableTanks, function(bulkTank){return {bulkTankId : bulkTank.getBulkTankId(), bulkTankName : bulkTank.getName()}});
		_bulkTankIds =  _.pluck(bulkTanksSimple, 'bulkTankId');

		var joined = _.reduce(consumableTanks, function(result, arr) {

			return result.concat(arr.getRobActions())
		}, []);


		var grouped = _.groupBy(joined, function(voyageBulk){
			return moment(voyageBulk.getDate(), g_timeStampFormat).format(g_timeStampFormat)
		});

		if(_.isEmpty(grouped)){
			addNewRob();
		}else{
			_.each(grouped, function(voyageBulkOnDate, date){
				var remarks;
				if(voyageBulkOnDate.length > 0){
					remarks = voyageBulkOnDate[0].getRemarks();
				}
				addRow(VRC.RobRow({date : date, remarks : remarks, voyageBulkOnDate : voyageBulkOnDate, bulkTankIds : _bulkTankIds}));
			})
		}


	};

	var deleteAll = function(){
		_.each(_robRows, function(robRow){
			robRow.removeAllVoyageBulk();
		});
		clear();
	};

	var clear = function(){


		_robRows = {};
	};


	var addNewRob = function(date){

		date = date || moment().endOf("day");

		var row = VRC.RobRow({date : date.format(g_timeStampFormat), voyageBulkOnDate : [], bulkTankIds : _bulkTankIds});
		addRow(row);
		return row;
	};

	var addRow = function(row){
		_robRows[moment(row.getDate(), g_timeStampFormat).format(KEY_FORMAT)] = row;
	};

	var getLastestRow = function(){
		var keys = _.keys(_robRows);
		if(_.isEmpty(keys)){
			return null;
		}

		var maxKey =  _.max(keys, function(key){return key});
		return _robRows[maxKey];
	};

	var hasDate = function(date){
		return getRow(date) !== undefined;
	};

	var toJson = function(){
		var ordered = _.sortBy(_robRows, function(row){

			return moment(row.getDate(), g_timeStampFormat).valueOf();

		});
		return  _.map(ordered, function(row){return row.toJson()});
	};

	var getRows = function(){
		return _robRows;
	};

	var getRow = function(date){
		var key  = moment(date, g_timeStampFormat).format(KEY_FORMAT);
		return _robRows[key];
	};

	var removeRow = function(date){
		var key  = moment(date, g_timeStampFormat).format(KEY_FORMAT);
		var robRow = _robRows[key];
		robRow.removeAllVoyageBulk();
		delete _robRows[key];

	}

	var updateIndex = function(oldKey, newKey){
		oldKey  = moment(oldKey, g_timeStampFormat).format(KEY_FORMAT);
		newKey  = moment(newKey, g_timeStampFormat).format(KEY_FORMAT);
		var rob  = _robRows[oldKey];
		_robRows[newKey] = rob;
		delete _robRows[oldKey];
	};

	return {
		addRobRow : addRow,
		addNewRob : addNewRob,
		removeRow : removeRow,
		toJson : toJson,
		getRows : getRows,
		getRow : getRow,
		hasDate : hasDate,
		updateIndex : updateIndex,
		getLastestRow : getLastestRow,
		init : init,
		clear : clear,
		deleteAll : deleteAll
	}
})();
